import React, { useState } from "react";

export default function PolicyPage() {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.mainTitle}>CoolFix Policies</h1>

      {/* Privacy Policy Section */}
      <div style={styles.section}>
        <h2
          style={styles.clickableTitle}
          onClick={() => toggleSection("privacy")}
        >
          🔒 Privacy Policy
        </h2>
        {openSection === "privacy" && (
          <div style={styles.content}>
            <p>
              CoolFix Services Private Limited ("CoolFix", "we", "us", or "our")
              is committed to protecting your privacy. This Privacy Policy
              explains how we collect, use, share, and safeguard your personal
              information when you use our mobile app and services.
            </p>

            <h3>1. Information We Collect</h3>
            <p>
              - Your name, phone number, and service address <br />
              - Booking details (service, date, and time) <br />
              - Feedback or reviews <br />
              - Identity verification documents uploaded by technicians
            </p>

            <h3>2. How We Use Your Information</h3>
            <p>
              - Schedule and fulfill service appointments <br />
              - Communicate via SMS, email, or phone calls <br />
              - Send updates or offers <br />
              - Improve our app & support <br />- Comply with legal obligations
            </p>

            <h3>3. Sharing of Information</h3>
            <p>
              We do not sell or rent your data. We may share with: <br />
              - Verified technicians <br />
              - Trusted providers (payments, analytics, hosting) <br />
              - Govt./legal authorities when required
            </p>

            <h3>4. Data Security</h3>
            <p>
              We use technical & organizational measures to protect your data.
              However, no method is 100% secure. Technician identity docs may be
              stored via{" "}
              <a
                href="https://imgbb.com/tos"
                target="_blank"
                rel="noopener noreferrer"
              >
                ImageBB (Terms)
              </a>
              .
            </p>

            <h3>5. Data Retention</h3>
            <p>
              We retain your data as long as needed to provide services or meet
              legal obligations.
            </p>

            <h3>6. Your Rights</h3>
            <p>
              - Access, correct, or delete data <br />
              - Withdraw consent <br />
              - Contact us for privacy concerns
            </p>

            <h3>7. Consent</h3>
            <p>
              By using our app, you consent to this Privacy Policy and our data
              practices.
            </p>

            <h3>8. Changes</h3>
            <p>
              We may update this policy. Continued use means you accept changes.
            </p>

            <h3>9. Contact Us</h3>
            <p>
              📧 Email:{" "}
              <a href="mailto:coolfixd@gmail.com">coolfixd@gmail.com</a>
            </p>
          </div>
        )}
      </div>

      {/* Refund & Cancellation Section */}
      <div style={styles.section}>
        <h2
          style={styles.clickableTitle}
          onClick={() => toggleSection("refund")}
        >
          💳 Refund & Cancellation Policy
        </h2>
        {openSection === "refund" && (
          <div style={styles.content}>
            <p>
              At <strong>Coolfix</strong>, we are committed to providing the
              best home services experience.
            </p>

            <h3>Cancellation Policy</h3>
            <p>
              - Customers can cancel their booking{" "}
              <strong>before the service is scheduled</strong>. <br />
              - In such cases, no payment will be processed. <br />
              - Once the service has started or completed, cancellation is not
              allowed.
            </p>

            <h3>Refund Policy</h3>
            <p>
              - Payments are made only after service completion. <br />
              - Once a service is marked as completed and payment is made,{" "}
              <strong>no refund will be provided</strong>. <br />
              - Please ensure satisfaction before completing payment.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have any questions, contact us at: <br />
              📧{" "}
              <a href="mailto:coolfixdd@gmail.com">coolfixd@gmail.com</a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    maxWidth: "900px",
    margin: "auto",
    fontFamily: "Arial, sans-serif",
  },
  mainTitle: {
    textAlign: "center",
    marginBottom: "20px",
  },
  section: {
    borderBottom: "1px solid #ddd",
    padding: "10px 0",
  },
  clickableTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "#007bff",
  },
  content: {
    marginTop: "10px",
    fontSize: "16px",
    lineHeight: "1.6",
  },
};
